import TablePage from '@/found/components/table_page';

export default {
  name: 'terminal_balance',
  extends: TablePage,
  data() {
    return {};
  },
  components: {

  },
  created() {
    this.getConfigList('terminal_balance_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        console.log(this.modalConfig);
        this.modalConfig.title = val.name || '查看';
        this.openModal();
      }
    },
  },
};
